// extracted by mini-css-extract-plugin
module.exports = {"root":"table_root__3zufT"};